// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 2H2V11H11V2Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 2V11H22V2H13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 13H13V22H22V13Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M11 22V13H2V22H11Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-frame-filled')
export default class FrameFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'frame-filled',
    }
  }
}
